const cards = [
  {
    title: '古装权谋巅峰《长安十二时辰》全集上线',
    desc: '雷佳音、易烊千玺主演，盛世长安危机四伏，一场惊心动魄的生死追凶，高清修复版免费看',
    tag: '热播推荐',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20intricate%20costumes%20and%20lanterns%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20Tang%20dynasty%20architecture%2C%20soft%20atmospheric%20haze%2C%20rich%20color%20palette%20of%20red%20and%20gold%2C%20editorial%20photography%20style%2C%20moody%20dramatic%20tone&width=800&height=450&seq=card-1-ql&orientation=landscape',
    icon: 'ri-fire-line',
  },
  {
    title: '现象级科幻巨制《流浪地球3》4K 独家呈现',
    desc: '吴京、刘德华再度携手，人类命运共同体史诗终章，震撼视觉盛宴',
    tag: '最新上线',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20scene%20with%20massive%20space%20station%20and%20neon%20blue%20lights%2C%20cosmic%20background%20with%20stars%2C%20cinematic%20widescreen%20composition%2C%20cool%20metallic%20tones%20with%20warm%20accent%20highlights%2C%20epic%20scale%2C%20clean%20modern%20aesthetic&width=800&height=450&seq=card-2-ql&orientation=landscape',
    icon: 'ri-rocket-line',
  },
  {
    title: '治愈系神作《去有风的地方》重温慢生活',
    desc: '刘亦菲、李现田园治愈之旅，云南大理实景拍摄，每一帧都是壁纸级画面',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Peaceful%20rural%20Chinese%20landscape%20with%20rice%20terraces%20and%20traditional%20wooden%20houses%2C%20warm%20sunset%20light%2C%20soft%20pastoral%20atmosphere%2C%20serene%20countryside%20vibe%2C%20healing%20natural%20scenery%2C%20gentle%20rolling%20hills%2C%20cinematic%20photography&width=800&height=450&seq=card-3-ql&orientation=landscape',
    icon: 'ri-heart-line',
  },
  {
    title: '《繁花》沪上风云 王家卫美学尽收眼底',
    desc: '胡歌领衔，90年代上海滩商战传奇，每一帧都是电影级画面质感',
    tag: '高分推荐',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Shanghai%20night%20street%20scene%20with%20neon%20signs%20and%20art%20deco%20buildings%2C%201990s%20Chinese%20urban%20atmosphere%2C%20warm%20golden%20streetlights%2C%20cinematic%20noir%20aesthetic%2C%20rain-slicked%20pavement%2C%20nostalgic%20mood%2C%20rich%20contrast&width=800&height=450&seq=card-4-ql&orientation=landscape',
    icon: 'ri-star-line',
  },
  {
    title: '悬疑烧脑天花板《漫长的季节》全集免费',
    desc: '范伟、秦昊封神演技，东北小城跨越二十年的命运纠葛，豆瓣9.4高分',
    tag: '口碑神剧',
    img: 'https://readdy.ai/api/search-image?query=Moody%20northeastern%20Chinese%20industrial%20town%20in%20autumn%2C%20misty%20atmosphere%2C%20railway%20tracks%20and%20old%20factory%20buildings%2C%20nostalgic%20melancholic%20tone%2C%20soft%20diffused%20light%2C%20cinematic%20composition%2C%20golden%20and%20russet%20leaves%2C%20atmospheric%20haze&width=800&height=450&seq=card-5-ql&orientation=landscape',
    icon: 'ri-brain-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            今日精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            每日精选热门影视内容，好剧好片一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className={`bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 group cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    idx === 0 ? 'h-52 md:h-64' : 'h-44 md:h-52'
                  }`}
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium backdrop-blur-sm">
                  <i className={card.icon}></i>
                  {card.tag}
                </div>
                {idx === 0 && (
                  <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/60 to-transparent"></div>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}